import SubmitButtonStyleBase from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/submitButtonStyleBase";
import SubmitButtonStyleDisabled from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/submitButtonStyleLoading";
import SubmitButtonStyleLoading from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/submitButtonStyleLoading";
import * as React from 'react';
export default {
  SubmitButtonStyleBase,
  SubmitButtonStyleDisabled,
  SubmitButtonStyleLoading,
  React
};